import React, { useState, useEffect } from "react"

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,

  Label,
  Row,
  TabContent,
  TabPane,
  CardImg
} from "reactstrap"
import { Link } from "react-router-dom"
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import _, { head, lowerCase } from 'lodash'
import Select from "react-select"
import Dropzone from "react-dropzone"
import SweetAlert from "react-bootstrap-sweetalert"
// MomentJS
import moment from 'moment'
import { CircularProgress } from "@material-ui/core";


const AddPaymentMethods = (props) => {

  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" }
  ]

  const typeOptions = [
    { value: "main", label: "Main" },
    { value: "sub", label: "Sub" }
  ]

  const [token, setToken] = useState()
  const [selectedFiles, setselectedFiles] = useState([])
  const [selectedType, setselectedType] = useState(typeOptions[0].value)
  const [selectedPosition, setselectedPosition] = useState(1)
  const [selectedStatus, setselectedStatus] = useState(statusOptions[0])
  const [Edit, setEdit] = useState(false)
  const [itemData, setItemData] = useState({})
  const [success_msg, setsuccess_msg] = useState(false)
  const [errorMessage, SetErrorMessage] = useState('')
  const [errorMsgAlert, setErrorMsgAlert] = useState(false)
  const [activeTab, setactiveTab] = useState(1)
  const [imageURL, setImageUrl] = useState('')
  const [successMsgText, setSuccessMsgText] = useState('')
  const [loader,setLoader]=useState(false)


  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab)
      }
    }
  }
  console.log("Props:  ", props)
  useEffect(() => {
    // console.log("Coming in edit page", props?.location?.state)
    const token = localStorage.getItem("AuthenticationToken")
    setToken(token)
    if(props?.location?.state?.edit){
        setEdit(true)
        if(props?.location?.state?.item){
            let item = props?.location?.state?.item
            // console.log("Item Data chck", item)
            setItemData(item)
            setImageUrl(item?.image_url)
            setselectedPosition(item?.sort_order)
            typeOptions?.map((itemT) => {
                if(itemT.value == item?.method_type){
                    setselectedType(itemT)
                    return
                }
            })
            if(item?.item_status == "Y"){
                setselectedStatus({ value: "Y", label: "Enable" })
            }else{
                setselectedStatus({ value: "N", label: "Disable" })
            }
        }
    }
  }, [success_msg])
  
  const validateFileSize = (file) => {
    console.log("here is the validate file----->", file);
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;
        if (width !== 70 || height !== 70) {
          SetErrorMessage("Height and Width must be 70X70px");
          setErrorMsgAlert(true);
        }else{
          handleAcceptedFiles(file);
        }
      };
    };
  };
  function handleAcceptedFiles(files) {
    files.map((file) =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })
  );
  let path = files[0].path;
  path = path.split(".");
  path = path[1];
  if (path == "PNG" || path == "png") {
    setselectedFiles(files);
  } else {
    SetErrorMessage("Please select a .png file");
    setErrorMsgAlert(true);
  }
  }

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
         props?.history.push(`/payments`)
          setsuccess_msg(false)
          setLoader(false)
        }}
        onConfirm={() => {
          props?.history.push(`/payments`)
          setsuccess_msg(false)
          setLoader(false)
        }}
        onCancel={() => {
          setsuccess_msg(false)
        }}
      >
        {successMsgText ? successMsgText : "Payment Method Added."}
      </SweetAlert>
    )
  }

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }

  function handleSubmit() {
    const name = document.getElementById("name_input").value;
    const external_link = document.getElementById("external_link_input").value;
    const alternate_url = document.getElementById("alternate_url_input").value;
    const selectedType1 = selectedType ? selectedType.value : ""
    const status = selectedStatus ? selectedStatus.value : ""
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
    currentDate = currentDate.toString()

    if(!name){
      setErrorMsgAlert(true)
      SetErrorMessage("Please Enter Name")
      return
    }
    else if(!external_link){
      setErrorMsgAlert(true)
      SetErrorMessage("Please Enter External Link")
      return
    }
    else if(!alternate_url){
      setErrorMsgAlert(true)
      SetErrorMessage("Please Enter Alternative Url")
      return
    }else if(!selectedType1){
      setErrorMsgAlert(true)
      SetErrorMessage("Please Enter Type")
      return
    }
    else if (selectedFiles.length < 1) {
        SetErrorMessage("Please select image")
        setErrorMsgAlert(true)
        return
      } else if (status == '') {
        SetErrorMessage("Please select status")
        setErrorMsgAlert(true)
        return
      }

      setLoader(true)

    var myHeaders = new Headers();

    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var formdata = new FormData();
    
        formdata.append("path", "paymentmethods/add");
        formdata.append("payment_method_name", name);
        formdata.append("external_link", external_link);
        formdata.append("alternate_url", alternate_url);
        formdata.append("created_datetime", currentDate);
        formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
        formdata.append("method_type", selectedType1);
        formdata.append("item_status", status);
        formdata.append("item_type", "\"payment_method\"");
        formdata.append("sort_order", selectedPosition);
        formdata.append("api", true);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(response => {
        if (response.status == 200) {
          setsuccess_msg(true)
          setLoader(false)
        } else {
          SetErrorMessage("Unable to Add Payment Method")
          setErrorMsgAlert(true)
          setLoader(false)
        }
        response.json()
      })
      .then(result => { })
      .catch(error => console.log('error', error));

  }
  function handleUpdate() {
    const name = document.getElementById("name_input").value;
    const external_link = document.getElementById("external_link_input").value;
    const alternate_url = document.getElementById("alternate_url_input").value;
    const selectedType1 = selectedType ? selectedType.value : ""
    const status = selectedStatus ? selectedStatus.value : ""
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
    currentDate = currentDate.toString()

    if(!name){
      setErrorMsgAlert(true)
      SetErrorMessage("Please Enter Name")
      return
    }
    else if(!external_link){
      setErrorMsgAlert(true)
      SetErrorMessage("Please Enter External Link")
      return
    }
    else if(!alternate_url){
      setErrorMsgAlert(true)
      SetErrorMessage("Please Enter Alternative Url")
      return
    }else if(!imageURL){
      if(selectedFiles.length < 1){
        setErrorMsgAlert(true)
        SetErrorMessage("Please Select Image")
        return
      }
    }

    setLoader(true)

    var myHeaders = new Headers();

    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

    var formdata = new FormData();    
        formdata.append("path", "paymentmethods/update");
        formdata.append("item_id", itemData?.item_id);
        formdata.append("payment_method_name", name);
        formdata.append("external_link", external_link);
        formdata.append("alternate_url", alternate_url);
        formdata.append("created_datetime", currentDate);
        if(selectedFiles?.length > 0){
          formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
        } 
        formdata.append("method_type", selectedType1);
        formdata.append("item_status", status);
        formdata.append("item_type", "\"payment_method\"");
        formdata.append("sort_order", selectedPosition);
        formdata.append("api", true);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(response => {
        if (response.status == 200) {
          setsuccess_msg(true)
          setLoader(false)
          setSuccessMsgText("Payment Method Updated Successfully.")
        } else {
          SetErrorMessage("Unable to Add Payment Method")
          setErrorMsgAlert(true)
          setLoader(false)
        }
        response.json()
      })
      .then(result => { })
      .catch(error => console.log('error', error));

  }

//   const validateFileSize = (file) => {
//     var reader = new FileReader();

//     //Read the contents of Image File.
//     reader.readAsDataURL(file[0]);
//     reader.onloadend = function (e) {
//       //Initiate the JavaScript Image object.
//       var image = new Image();

//       //Set the Base64 string return from FileReader as source.
//       image.src = e.target.result;
//       //Validate the File Height and Width.
//       image.onload = function () {
//         var height = this.height;
//         var width = this.width;

//         if (width !== 640 || height !== 440) {
//           SetErrorMessage("Height and Width must be 640x440px")
//           setErrorMsgAlert(true)
//           // alert("Height and Width must be 600px.");
//           return false;
//         }
//         // alert("Uploaded image has valid Height and Width.");
//         handleAcceptedFiles(file)
//         return true;
//       };
//     };
//   }
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Payment Methods" breadcrumbItem={`${Edit ? "Edit" : "Add"} Payment Method`} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <div className="content clearfix">
                      <div className="body">
                        <TabContent
                          activeTab={activeTab}
                        >
                          <TabPane tabId={1}>
                            <Form>
                              <Row>
                              </Row>
                            </Form>
                            <Row>
                              <Col className="col-12">
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={10} md={10} sm={10}>
                                        <div className="mt-5 mt-lg-4">
                                          <Form
                                            className=""
                                            method="post"
                                            id="tooltipForm">
                                            <div>

                                            <Row>
                                    <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Position</Label>
                                          <div className="col-md-12">
                                                <input
                                                      onChange={(e) => setselectedPosition(e.target.value)}
                                                      className="form-control"
                                                      type="number"
                                                      id="position_input"
                                                      value={selectedPosition}
                                                      min={1}
                                                    />
                                          </div>
                                        </div>
                                      </Col>
                                      <Col lg={1}></Col>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Name</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="text"
                                              id="name_input"
                                              defaultValue={itemData?.payment_method_name ? itemData?.payment_method_name : ""}
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                              <Row>
                                    <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>External Deeplink</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="text"
                                              id="external_link_input"
                                              placeholder="https://grabPay.com/pay"
                                              defaultValue={itemData?.external_link ? itemData?.external_link : ""}
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      <Col lg={1}></Col>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Alternate URL</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="text"
                                              id="alternate_url_input"
                                              placeholder="https://grabPay.com/pay"
                                              defaultValue={itemData?.alternate_url ? itemData?.alternate_url : ""}
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                    <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Type</Label>
                                          <div className="col-md-12">
                                          <Select
                                            isSearchable={true}
                                            value={selectedType}
                                            onChange={(e) => {
                                              setselectedType(e)
                                            }}
                                            options={typeOptions}
                                            placeholder={selectedType ? selectedType.label : "Choose..."}
                                            defaultValue={typeOptions[0].label}
                                            required
                                          />
                                          </div>
                                        </div>
                                      </Col>
                                      <Col lg={1}></Col>
                                    </Row>
                                    
                                            </div>
                                          </Form>
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                  {imageURL &&
                    <Row>
                      <Col lg={1}>
                      <CardImg className="img-fluid" src={imageURL}
                        style={{ marginBottom: 15, width: 150}}
                        alt="" />
                      </Col>
                      <Col>
                      <div className="px-3 text-danger"
                      style={{cursor:"pointer"}}
                      onClick={()=>{
                        setImageUrl("")
                      }}
                      ><FaRegTrashAlt />Move To Trash</div>
                      </Col>
                  </Row>}
                                    <Form>
                                      <Dropzone
                                        onDrop={acceptedFiles => {
                                          validateFileSize(acceptedFiles)
                                        }}
                                      >
                                        {({ getRootProps, getInputProps }) => (
                                          <div className="dropzone">
                                            <div
                                              className="dz-message needsclick"
                                              {...getRootProps()}
                                            >
                                              <input {...getInputProps()} />
                                              <div className="mb-3">
                                                <FaCloudUploadAlt className="display-4 text-muted"/>
                                              </div>
                                              <h4>Drop files here or click to upload.</h4>
                                              <p
                                            style={{
                                              fontSize: 12,
                                              color: "red",
                                            }}
                                          >
                                            Image should be 70X70px in png
                                          </p>
                                            </div>
                                          </div>
                                        )}
                                      </Dropzone>
                                      <div className="dropzone-previews mt-3" id="file-previews">
                                        {selectedFiles.map((f, i) => {
                                          return (
                                            <Card
                                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                              key={i + "-file"}
                                            >
                                              <div className="p-2">
                                                <Row className="align-items-center">
                                                  <Col className="col-auto">
                                                    <img
                                                      data-dz-thumbnail=""
                                                      height="80"
                                                      className="avatar-sm rounded bg-light"
                                                      alt={f.name}
                                                      src={f.preview}
                                                    />
                                                  </Col>
                                                  <Col>
                                                    <Link
                                                      to="#"
                                                      className="text-muted font-weight-bold"
                                                    >
                                                      {f.name}
                                                    </Link>
                                                    <p className="mb-0">
                                                      <strong>{f.formattedSize}</strong>
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </Card>
                                          )
                                        })}
                                      </div>
                                    </Form>

                                    {/* <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Send Files
                    </button>
                  </div> */}
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Status</Label>
                                          <Select
                                            isSearchable={true}
                                            // value={selectedStatus}
                                            onChange={(e) => {
                                              setselectedStatus(e)
                                            }}
                                            options={statusOptions}
                                            placeholder={selectedStatus ? selectedStatus.label : "Choose..."}
                                            defaultValue={statusOptions[0].label}
                                            required
                                          />
                                        </div>
                                      </Col>
                                      <Col lg={1}></Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                      <li
                          className={
                            "next"
                          }
                        >
                          <Link
                            to={`/payments`}
                            className="bg-danger"
                            // onClick={() => {
                            //   toggleTab(activeTab - 1)
                            // }}
                            style={{paddingTop:8, paddingBottom:10}}
                          >
                            Cancel
                          </Link>
                        </li>
                        <li
                          className={"next"}
                        >
                          <button
                          disabled={loader}
                          style={{color:"#ffffff", width:"80px"}}
                          className={ "btn btn-success"}
                            onClick={() => {
                              if(props?.location?.state?.edit){
                                handleUpdate()
                              }else{
                                handleSubmit()
                              }
                            }}
                          >
                            {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                          </button>
                        </li>
                      </ul>
                    </div>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {success_msg ? (
            renderSuccessAlert()
          )
            :
            null
          }
          {errorMsgAlert ? (
            renderFailureAlert()
          )
            :
            null
          }
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddPaymentMethods
